import { EGender } from '@/types/auth'

export const accountSidebarMenu = [
  {
    title: 'account_page.title.account_info',
    image: '/image/2026/12/23/mceclip6_34.png',
    link: '/account/info',
  },
  {
    title: 'account_page.title.refer_friend',
    image: '/image/September2024/mceclip0.png',
    link: '/account/refer-friend',
  },
  {
    title: 'account_page.title.friends_of_coolmate',
    image: '/image/2026/08/13/group.png',
    link: '/account/friends-of-coolmate',
  },
  {
    title: 'account_page.title.order_history',
    image: '/image/September2023/mceclip4_7.png',
    link: '/account/orders',
  },
  {
    title: 'account_page.title.coolcash_point',
    image: '/image/September2023/mceclip5_85.png',
    link: '/account/coolcash-point',
  },
  {
    title: 'account_page.title.voucher_wallet',
    image: '/image/September2023/mceclip1_59.png',
    link: '/account/voucher-wallet',
  },
  {
    title: 'account_page.title.user_address',
    image: '/image/September2023/mceclip2_76.png',
    link: '/account/user-address',
  },
  {
    title: 'account_page.title.reviews_and_feedback',
    image: '/image/September2023/mceclip3_71.png',
    link: '/account/reviews',
  },
  {
    title: 'account_page.title.policy_and_faq',
    image: '/image/September2023/mceclip5_95.png',
    link: '/account/faq',
  },
  {
    title: 'account_page.title.logout',
    image: '/image/2026/09/22/Rectangle_33321.png',
    link: '#logout',
  },
]

export const genderMapping = {
  [EGender.MALE]: 'title.gender.male',
  [EGender.FEMALE]: 'title.gender.female',
  [EGender.OTHER]: 'title.gender.other',
}

export const reviewModalContent = {
  description: [
    {
      label: 'account_page.review_content.0.label',
      label2: 'account_page.review_content.0.label2',
    },
    {
      label: 'account_page.review_content.1.label',
      label2: 'account_page.review_content.1.label2',
    },
    {
      label: 'account_page.review_content.2.label',
      label2: 'account_page.review_content.2.label2',
    },
    {
      label: 'account_page.review_content.3.label',
      label2: 'account_page.review_content.3.label2',
    },
    {
      label: 'account_page.review_content.4.label',
      label2: 'account_page.review_content.4.label2',
    },
  ],
  positiveTags: [
    {
      key: 'dep-nhu-mo-ta',
      label: 'account_page.review_tags.beautiful_as_described',
    },
    { key: 'gia-hop-ly', label: 'account_page.review_tags.reasonable_price' },
    {
      key: 'dong-goi-can-than',
      label: 'account_page.review_tags.careful_packaging',
    },
    {
      key: 'chat-vai-thoang-mat',
      label: 'account_page.review_tags.breathable_fabric',
    },
    { key: 'tham-hut-tot', label: 'account_page.review_tags.good_absorption' },
  ],
  tags: [
    [
      {
        key: 'san-pham-bi-loi',
        label: 'account_page.review_tags.product_error',
      },
      {
        key: 'khong-ung-chat-lieu-form-dang',
        label: 'account_page.review_tags.not_like_material_or_fit',
      },
      { key: 'khong-vua-size', label: 'account_page.review_tags.not_fit_size' },
      { key: 'mau-sac-xau', label: 'account_page.review_tags.ugly_color' },
      {
        key: 'dong-goi-chua-tot',
        label: 'account_page.review_tags.bad_packaging',
      },
      {
        key: 'gui-sai-thieu-san-pham',
        label: 'account_page.review_tags.send_wrong_or_missing_product',
      },
      {
        key: 'giao-hang-cham',
        label: 'account_page.review_tags.slow_delivery',
      },
      {
        key: 'thai-do-buu-ta-te',
        label: 'account_page.review_tags.bad_service',
      },
      {
        key: 'thai-do-tu-van',
        label: 'account_page.review_tags.bad_consultation',
      },
      { key: 'khac', label: 'account_page.review_tags.other' },
    ],
    [
      {
        key: 'san-pham-bi-loi',
        label: 'account_page.review_tags.product_error',
      },
      {
        key: 'khong-ung-chat-lieu-form-dang',
        label: 'account_page.review_tags.not_like_material_or_fit',
      },
      { key: 'khong-vua-size', label: 'account_page.review_tags.not_fit_size' },
      { key: 'mau-sac-xau', label: 'account_page.review_tags.ugly_color' },
      {
        key: 'dong-goi-chua-tot',
        label: 'account_page.review_tags.bad_packaging',
      },
      {
        key: 'gui-sai-thieu-san-pham',
        label: 'account_page.review_tags.send_wrong_or_missing_product',
      },
      {
        key: 'giao-hang-cham',
        label: 'account_page.review_tags.slow_delivery',
      },
      {
        key: 'thai-do-buu-ta-te',
        label: 'account_page.review_tags.bad_service',
      },
      {
        key: 'thai-do-tu-van',
        label: 'account_page.review_tags.bad_consultation',
      },
      { key: 'khac', label: 'account_page.review_tags.other' },
    ],
    [
      { key: 'san-pham-bi-loi', label: 'acc' },
      {
        key: 'khong-ung-chat-lieu-form-dang',
        label: 'account_page.review_tags.not_like_material_or_fit',
      },
      { key: 'khong-vua-size', label: 'account_page.review_tags.not_fit_size' },
      { key: 'mau-sac-xau', label: 'account_page.review_tags.ugly_color' },
      {
        key: 'dong-goi-chua-tot',
        label: 'account_page.review_tags.bad_packaging',
      },
      {
        key: 'gui-sai-thieu-san-pham',
        label: 'account_page.review_tags.send_wrong_or_missing_product',
      },
      {
        key: 'giao-hang-cham',
        label: 'account_page.review_tags.slow_delivery',
      },
      {
        key: 'thai-do-buu-ta-te',
        label: 'account_page.review_tags.bad_service',
      },
      {
        key: 'thai-do-tu-van',
        label: 'account_page.review_tags.bad_consultation',
      },
      { key: 'khac', label: 'account_page.review_tags.other' },
    ],
    [
      {
        key: 'san-pham-dep',
        label: 'account_page.review_tags.beautiful_product',
      },
      { key: 'gia-tot', label: 'account_page.review_tags.good_price' },
      {
        key: 'dong-goi-dep',
        label: 'account_page.review_tags.beautiful_packaging',
      },
      {
        key: 'giao-hang-nhanh',
        label: 'account_page.review_tags.fast_delivery',
      },
      {
        key: 'cham-soc-khach-hang-tan-tinh',
        label: 'account_page.review_tags.good_customer_service',
      },
    ],
    [
      {
        key: 'san-pham-dep',
        label: 'account_page.review_tags.beautiful_product',
      },
      { key: 'gia-tot', label: 'account_page.review_tags.good_price' },
      {
        key: 'dong-goi-dep',
        label: 'account_page.review_tags.beautiful_packaging',
      },
      {
        key: 'giao-hang-nhanh',
        label: 'account_page.review_tags.fast_delivery',
      },
      {
        key: 'cham-soc-khach-hang-tan-tinh',
        label: 'account_page.review_tags.good_customer_service',
      },
    ],
  ],
}
